import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { TwitterShareButton, TwitterIcon } from 'react-share';
import { SelectSessionButton } from 'KeysAndSigningUI';
import { Score } from 'MonadomCoreUI';
import { TextLine3, ForDevelopment } from 'UtilComponents';
import { useGlobalStateSelector, words } from 'globalState';
import { handleClickGetDuelHistoryAll } from 'duelHistory';
import {
  handleClickGoBack,
  copyDuelHistoryStoryToClipboard,
  downloadDuelHistoryStoryImage,
  copyDuelHistoryKnightBoxesToClipboard,
  downloadDuelHistoryKnightBoxesImage,
} from 'monadomCore';
import {
  devLog,
  setEpochTime,
  localTime,
} from 'utils';
import { otherSide, borderColor, magicNarration } from 'utils/utilsKom';
import { copyToClipboard } from 'utils/utilsBrowser';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconCopy from './content_copy_FILL0_wght400_GRAD0_opsz48.svg';
import iconDownload from './image/download_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconShare from './share_FILL0_wght400_GRAD0_opsz48.svg';
import iconHeaderFooter from './ad_units_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import roseRed from './roseRed.png';
import roseBlue from './roseBlue.png';
import emblemRed from './emblemRed.png';
import emblemBlue from './emblemBlue.png';
import imageMagicRed from './magicRed.png';
import imageMagicBlue from './magicBlue.png';
import imageTarget from './target.png';
import imageCemetery from './cemetery.png';
import imageAnotherDimension from './anotherDimension.png';
import logoWin from './logoWin.png';
import logoLose from './logoLose.png';
import logoDraw from './logoDraw.png';

// DUEL HISTORY
function DuelHistory() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const location = useLocation();
  let historyItems;
  let historyFunction;
  let arrowLeft;
  let arrowRight;

  // アクションごとのhistoryItemsとhistoryFunction設定。

  if (state.getDuelHistory.action === 'duelHistoryAll') {
    if (state.duelHistoryAll.duelHistory !== undefined) {
      historyItems = state.duelHistoryAll.duelHistory.map( record => {
        if (true) {
          return <DuelRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<DuelRecordTitle />);
    }
    else {
      historyItems = [<DuelRecordTitle />];
    }

    historyFunction = (pagingIndex) => handleClickGetDuelHistoryAll(state, dispatch, pagingIndex);
  }

  if (state.getDuelHistory.action === 'duelHistoryAddress') {
    if (state.duelHistoryAddress.duelHistory !== undefined) {
      historyItems = state.duelHistoryAddress.duelHistory.map( record => {
        if (true) {
          return <DuelRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<DuelRecordTitle />);
    }
    else {
      historyItems = [<DuelRecordTitle />];
    }

    historyFunction = (pagingIndex) => handleClickGetDuelHistoryAll(state, dispatch, pagingIndex);
  }

  // 矢印

  if ( state.getDuelHistory.pagingIndex[state.getDuelHistory.action] >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => historyFunction(state.getDuelHistory.pagingIndex[state.getDuelHistory.action] - 1) }
      >
        <img className='size2x2' src={iconCircleLeft} alt='left' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if ( (state.getDuelHistory.lastEvaluatedKey[state.getDuelHistory.action][state.getDuelHistory.pagingIndex[state.getDuelHistory.action]] !== undefined &&
        state.getDuelHistory.lastEvaluatedKey[state.getDuelHistory.action][state.getDuelHistory.pagingIndex[state.getDuelHistory.action]] !== null        ) ||
       (state.getDuelHistory.lastEvaluatedKey2[state.getDuelHistory.action]?.[state.getDuelHistory.pagingIndex[state.getDuelHistory.action]] !== undefined &&
        state.getDuelHistory.lastEvaluatedKey2[state.getDuelHistory.action]?.[state.getDuelHistory.pagingIndex[state.getDuelHistory.action]] !== null        ) ) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { historyFunction(state.getDuelHistory.pagingIndex[state.getDuelHistory.action] + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='right' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  // ページングパラメータリセット関数

  const resetPagingParameters = () => {
    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'pagingIndex'],
      value: { duelHistoryAll: 0, duelHistoryAddress: 0 }
    });

    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey'],
      value: { duelHistoryAll: [], duelHistoryAddress: [] }
    });

    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey2'],
      value: { duelHistoryAll: [], duelHistoryAddress: [] }
    });
  };

  // アクション変更（→アドレス指定）ボタン

  const handleClickActionChangeToAddress = () => {
    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAddress' });
  };

  // アドレス取得ボタン

  // let getAddressButton;

  // if (state.walletType === 'mpurse') {
  //   getAddressButton =
  //   <button className='button1'
  //     onClick={ async () => {
  //       const result = await handleClickMpurse(state, dispatch, ['getDuelHistory', 'duelistAddress']);
  //       devLog('handleClickMpurse; result', JSON.stringify(result));

  //       if (result.status === 'fulfilled') {
  //         if (state.getDuelHistory.action !== 'duelHistoryAddress') {
  //           dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAddress' });
  //         }

  //         resetPagingParameters();
  //       }
  //       else {
  //         dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
  //       }
  //     }}
  //   >
  //     <img className='size2x2' src={iconMpurse} alt='mpurse' />
  //   </button>;
  // }
  // else if (state.walletType === 'nfc') {
  //   getAddressButton =
  //   <button className='button2 flexRow justifyContentCenter alignItemsCenter '
  //     onClick={ () => {
  //       const callback = (keyPairs) => {
  //         const result = getAddressFromKey(state, dispatch, keyPairs[0]);
  //         devLog('touch NFC to get address; result', JSON.stringify(result));

  //         if (result.status === 'fulfilled') {
  //           dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'duelistAddress'], value: result.address });

  //           if (state.getDuelHistory.action !== 'duelHistoryAddress') {
  //             dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAddress' });
  //           }

  //           resetPagingParameters();
  //         }
  //         else {
  //           dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
  //         }
  //       };

  //       handleClickNfc(state, dispatch, callback);
  //     }}
  //   >
  //     <div>
  //       { words.address[state.language] }
  //     </div>
  //     <div>
  //       <img className='size2x2' src={iconKeyCard} alt='keycard' />
  //     </div>
  //   </button>;
  // }
  // else { // qr
  //   getAddressButton =
  //   <button className='button2 flexRow justifyContentCenter alignItemsCenter '
  //     onClick={ () => {
  //       const callback = (keyPairs) => {
  //         const result = getAddressFromKey(state, dispatch, keyPairs[0]);
  //         devLog('touch NFC to get address; result', JSON.stringify(result));

  //         if (result.status === 'fulfilled') {
  //           dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'duelistAddress'], value: result.address });

  //           if (state.getDuelHistory.action !== 'duelHistoryAddress') {
  //             dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAddress' });
  //           }

  //           resetPagingParameters();
  //         }
  //         else {
  //           dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
  //         }
  //       };

  //       handleClickScanQr(state, dispatch, callback);
  //     }}
  //   >
  //     <div>
  //       { words.address[state.language] }
  //     </div>
  //     <div>
  //       <img className='size2x2' src={iconQr} alt='2D barcode' />
  //     </div>
  //   </button>;
  // }

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoBack(state, dispatch, navigate, location) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexColumn'>
          { headerRelative }
          {/* history */}
          <div className='flexRow justifyContentFlexStart alignItemsCenter '>
            {/* action */}
            <div className='flexRow justifyContentSpaceAround marginSide0p5 '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelHistory.action === 'duelHistoryAll' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll'});
                }}>
                {words.duelHistoryAll[state.language]}
              </button>
            </div>
            {/* duelistAddress */}
            <TextLine3 fieldName='historyAddressMain' keys={['getDuelHistory', 'duelistAddress']} face={words.duelistAddress[state.language]} tooltip={true}
              extraFunctionOnChange={ [
                {
                  function: (duelistAddress) => {
                    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'pagingIndex'],
                      value: { duelHistoryAll: 0, duelHistoryAddress: 0 }
                    });

                    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey'],
                      value: { duelHistoryAll: [], duelHistoryAddress: [] }
                    });

                    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey2'],
                      value: { duelHistoryAll: [], duelHistoryAddress: [] }
                    });

                    if (state.getDuelHistory.action === 'duelHistoryAddress') {
                      if (duelistAddress === undefined || duelistAddress === null || duelistAddress === '') {
                        dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll' });
                      }
                    }
                    else {
                      if (duelistAddress !== undefined && duelistAddress !== null && duelistAddress !== '') {
                        dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAddress' });
                      }
                    }
                  },
                  arguments: [],
                  targetValue: true,
                }
              ]}
            />
            <SelectSessionButton stateKeysToSetAddress={[['getDuelHistory', 'duelistAddress']]} stateKeysToSetUserName={[]} loginEnabled={false}
              extraFunction={ () => {
                handleClickActionChangeToAddress();
                resetPagingParameters();
              }}
            />
            {/*
              <button className='button1'
                onClick={ () => {
                  handleClickAddressHistory(state, dispatch, cookies, ['getPointHistory', 'addressMain']);
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'pagingIndex'],
                    value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
                  });
                  dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey'],
                    value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
                  });
                }}
              >
                <img className='size2x2' src={iconList} />
              </button>
            */}
            <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
              <img className='size2x2' src={iconSearch} alt='search' />
            </button>
            {/* range */}
            <div className='flexRow justifyContentFlexStart marginSide1 '>
              <div className='flexColumn alignItemsFlexStart justifyContentCenter '>
                <div className='flexColumn justifyContentCenter height2p2'>
                  <div>
                    from
                  </div>
                </div>
                <div className='flexColumn justifyContentCenter height2p2'>
                  <div>
                    to
                  </div>
                </div>
              </div>
              {/* from */}
              <div className='flexColumn alignItemsFlexStart justifyContentCenter '>
                <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                  <div className='marginSide0p5'>
                    <TextLine3 fieldName='searchDateRangeFromYear' keys={['searchDateRange', 'from', 'year']} face={'year'} type='setStateMultiLayersNum' boxClass='box4chars'
                      extraFunctionOnChange={ [
                        {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'from'], 'year'], targetValue: true},
                      ] } 
                    />
                  </div>
                  <div className='marginSide0p5'>
                    <TextLine3 fieldName='searchDateRangeFromMonth' keys={['searchDateRange', 'from', 'month']} face={'month'} type='setStateMultiLayersNum' boxClass='box4chars'
                      extraFunctionOnChange={ [
                        {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'from'], 'month'], targetValue: true},
                      ] } 
                    />
                  </div>
                  <div className='marginSide0p5'>
                    <TextLine3 fieldName='searchDateRangeFromDay' keys={['searchDateRange', 'from', 'day']} face={'day'} type='setStateMultiLayersNum' boxClass='box4chars'
                      extraFunctionOnChange={ [
                        {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'from'], 'day'], targetValue: true},
                      ] } 
                    />
                  </div>
                </div>
                {/* to */}
                <div className='flexRow justifyContentFlexStart alignItemsCenter ' >
                  <div className='marginSide0p5'>
                    <TextLine3 fieldName='searchDateRangeToYear' keys={['searchDateRange', 'to', 'year']} face={'year'} type='setStateMultiLayersNum' boxClass='box4chars'
                      extraFunctionOnChange={ [
                        {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'to'], 'year'], targetValue: true},
                      ] } 
                    />
                  </div>
                  <div className='marginSide0p5'>
                    <TextLine3 fieldName='searchDateRangeToMonth' keys={['searchDateRange', 'to', 'month']} face={'month'} type='setStateMultiLayersNum' boxClass='box4chars'
                      extraFunctionOnChange={ [
                        {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'to'], 'month'], targetValue: true},
                      ] } 
                    />
                  </div>
                  <div className='marginSide0p5'>
                    <TextLine3 fieldName='searchDateRangeToDay' keys={['searchDateRange', 'to', 'day']} face={'day'} type='setStateMultiLayersNum' boxClass='box4chars'
                      extraFunctionOnChange={ [
                        {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'to'], 'day'], targetValue: true},
                      ] } 
                    />
                  </div>
                </div>
              </div>
            </div>
            { arrowLeft }
            { arrowRight }
          </div>
          { historyItems }
          {/* development */}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess">
        <div className='flexColumn'>
          { headerRelative }
          {/* control */}
          {/* action */}
          <div className='flexRow justifyContentFlexStart '>
            <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelHistory.action === 'duelHistoryAll' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll'});
              }}>
              {words.duelHistoryAll[state.language]}
            </button>
          </div>
          {/* duelistAddress */}
          <div className='flexColumn justifyContentCenter alignItemsFlexStart marginBottom1 '>
            <TextLine3 fieldName='historyAddressMain' keys={['getDuelHistory', 'duelistAddress']} face={words.duelistAddress[state.language]} tooltip={true}
              extraFunctionOnChange={ [
                {
                  function: (duelistAddress) => {
                    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'pagingIndex'],
                      value: { duelHistoryAll: 0, duelHistoryAddress: 0 }
                    });

                    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey'],
                      value: { duelHistoryAll: [], duelHistoryAddress: [] }
                    });

                    dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'lastEvaluatedKey2'],
                      value: { duelHistoryAll: [], duelHistoryAddress: [] }
                    });

                    if (state.getDuelHistory.action === 'duelHistoryAddress') {
                      if (duelistAddress === undefined || duelistAddress === null || duelistAddress === '') {
                        dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll' });
                      }
                    }
                    else {
                      if (duelistAddress !== undefined && duelistAddress !== null && duelistAddress !== '') {
                        dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAddress' });
                      }
                    }
                  },
                  arguments: [],
                  targetValue: true,
                }
              ]}
            />
            <div className='flexRow justifyContentFlexStart alignItemsCenter '>
              <SelectSessionButton stateKeysToSetAddress={[['getDuelHistory', 'duelistAddress']]} stateKeysToSetUserName={[]} loginEnabled={false}
                extraFunction={ () => {
                  handleClickActionChangeToAddress();
                  resetPagingParameters();
                }}
              />
              {/*
                <button className='button1'
                  onClick={ () => {
                    handleClickAddressHistory(state, dispatch, cookies, ['getPointHistory', 'addressMain']);
                    dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'pagingIndex'],
                      value: { permit: 0, permitted: 0, permittedInclusively: 0, requestPermission: 0, requestedPermission: 0, delegate: 0, delegated: 0 }
                    });
                    dispatch({ type: 'setStateMultiLayers', keys: ['getPointHistory', 'lastEvaluatedKey'],
                      value: { permit: [], permitted: [], permittedInclusively: [], requestPermission: [], requestedPermission: [], delegate: [], delegated: [] }
                    });
                  }}
                >
                  <img className='size2x2' src={iconList} />
                </button>
              */}
              <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
                <img className='size2x2' src={iconSearch} alt='search' />
              </button>
            </div>
          </div>
          {/* range */}
          <div className='flexRow justifyContentFlexStart marginSide1 '>
            <div className='flexColumn alignItemsFlexStart justifyContentCenter '>
              <div className='flexColumn justifyContentCenter height2p2'>
                <div>
                  from
                </div>
              </div>
              <div className='flexColumn justifyContentCenter height2p2'>
                <div>
                  to
                </div>
              </div>
            </div>
            {/* from */}
            <div className='flexColumn alignItemsFlexStart justifyContentCenter '>
              <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                <div className='marginSide0p5'>
                  <TextLine3 fieldName='searchDateRangeFromYear' keys={['searchDateRange', 'from', 'year']} face={'year'} type='setStateMultiLayersNum' boxClass='box4chars'
                    extraFunctionOnChange={ [
                      {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'from'], 'year'], targetValue: true},
                    ] } 
                  />
                </div>
                <div className='marginSide0p5'>
                  <TextLine3 fieldName='searchDateRangeFromMonth' keys={['searchDateRange', 'from', 'month']} face={'month'} type='setStateMultiLayersNum' boxClass='box4chars'
                    extraFunctionOnChange={ [
                      {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'from'], 'month'], targetValue: true},
                    ] } 
                  />
                </div>
                <div className='marginSide0p5'>
                  <TextLine3 fieldName='searchDateRangeFromDay' keys={['searchDateRange', 'from', 'day']} face={'day'} type='setStateMultiLayersNum' boxClass='box4chars'
                    extraFunctionOnChange={ [
                      {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'from'], 'day'], targetValue: true},
                    ] } 
                  />
                </div>
              </div>
              {/* to */}
              <div className='flexRow justifyContentFlexStart alignItemsCenter ' >
                <div className='marginSide0p5'>
                  <TextLine3 fieldName='searchDateRangeToYear' keys={['searchDateRange', 'to', 'year']} face={'year'} type='setStateMultiLayersNum' boxClass='box4chars'
                    extraFunctionOnChange={ [
                      {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'to'], 'year'], targetValue: true},
                    ] } 
                  />
                </div>
                <div className='marginSide0p5'>
                  <TextLine3 fieldName='searchDateRangeToMonth' keys={['searchDateRange', 'to', 'month']} face={'month'} type='setStateMultiLayersNum' boxClass='box4chars'
                    extraFunctionOnChange={ [
                      {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'to'], 'month'], targetValue: true},
                    ] } 
                  />
                </div>
                <div className='marginSide0p5'>
                  <TextLine3 fieldName='searchDateRangeToDay' keys={['searchDateRange', 'to', 'day']} face={'day'} type='setStateMultiLayersNum' boxClass='box4chars'
                    extraFunctionOnChange={ [
                      {function: setEpochTime, arguments: [state, dispatch, ['searchDateRange', 'to'], 'day'], targetValue: true},
                    ] } 
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter margin1 '>
            { arrowLeft }
            { arrowRight }
          </div>
          { historyItems }
        </div>
      </div>
      { headerFixed }
    </div>
  );
}

// DUEL RECORD TITLE
function DuelRecordTitle() {
  const state = useGlobalStateSelector(({ state }) => state);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          {/*
            <div className='marginSide1 widthMin15' >
              { words.duelNo[state.language] }
            </div>
          */}
          <div className='marginSide1 widthMin12' >
            { words.duelistA[state.language] /* 赤 */ }
          </div>
          <div className='marginSide1 widthMin12' >
            { words.duelistB[state.language] /* 青 */ }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.winner[state.language] }
          </div>
          {/*
            <div className='marginSide1 widthMin15' >
              { words.loser[state.language] }
            </div>
          */}
          <div className='marginSide1 widthMin7' >
            { words.point[state.language] }
          </div>
          <div className='marginSide1 widthMin20' >
            { words.finisher[state.language] }
          </div>
          <div className='marginSide1 widthMin12' >
            { words.startTime[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// DUEL RECORD
function DuelRecord(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const record = props.record;
  const result = record.result;
  const finisher = result[record.round].monsters[result[record.round].winner];
  let buttons;
  let popup;

  popup = { type: 'duelHistoryDetail', body: record };
  buttons =
  <button className='button1'
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'round'], value: 0 });
      // dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 100], value: popup });
      navigate(
        process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistorydetail' : '/duelhistorydetail',
        { state: { previousLocation: 'duelhistory' } }
      )
    }}
  >
    <img className='size2x2' src={iconDetail} alt='detail' />
  </button>;

  let duelWinnerColorAndName;

  if (record.duelWinner === 'A') {
    duelWinnerColorAndName = words.duelistA[state.language] + ' - ' + record.duelistAUserName;
  }
  else if (record.duelWinner === 'B') {
    duelWinnerColorAndName = words.duelistB[state.language] + ' - ' + record.duelistBUserName;
  }
  else if (record.duelWinner === 'draw') {
    duelWinnerColorAndName = 'draw';
  }
  else {
    duelWinnerColorAndName = '-';
  }

  let finisherName;

  if (finisher !== undefined) {
    finisherName = state.registeredCard[finisher]?.name;
  }
  else {
    finisherName = '-';
  }

  let point;

  if (result[record.round].reason === 'normal' || result[record.round].reason === 'additionalJudgement') {
    point = record.pointA + ' - ' + record.pointB;
  }
  else if (result[record.round].reason === 'timeUp') {
    point = words.timeup[state.language];
  }
  else if (result[record.round].reason === 'leave') {
    point = words.leftTheGame[state.language];
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          {/*
            <div className='marginSide1 widthMin15' >
              { 'hoge' + record.roomId + '-' + record.duelNo }
            </div>
          */}
          <div className='marginSide1 widthMin12' >
            { record.duelistAUserName }
          </div>
          <div className='marginSide1 widthMin12' >
            { record.duelistBUserName }
          </div>
          <div className='marginSide1 widthMin15' >
            { duelWinnerColorAndName }
          </div>
          <div className='marginSide1 widthMin7' >
            { point }
          </div>
          <div className='marginSide1 widthMin20' >
            { finisherName }
          </div>
          <div className='marginSide1 widthMin12' >
            { localTime(record.startTime, 'yearToSecond' ) }
          </div>
          { buttons }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentFlexEnd alignItemsCenter width98PC'>
            { buttons }
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.duelistA[state.language] /* 赤 */ }
            </div>
            <div className='flexRow alignItemsCenter' >
              { record.duelistAUserName }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.duelistB[state.language] /* 青 */ }
            </div>
            <div className='' >
              { record.duelistBUserName }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.winner[state.language] }
            </div>
            <div className='' >
              { duelWinnerColorAndName }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.point[state.language] }
            </div>
            <div className='' >
              { point }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.finisher[state.language] }
            </div>
            <div className='' >
              { finisherName }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.startTime[state.language] }
            </div>
            <div className='' >
              { localTime(record.startTime, 'yearToSecond' ) }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// DUEL HISTORY DETAIL
function DuelHistoryDetail(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const location = useLocation();
  const popupLayer = props.popupLayer;
  const record = state.popup[props.popupLayer].body;
  const round = state.getDuelHistory.round;
  const thisRound = record.result[round];

  // デッキ

  const deckA =
  <div className='boxDeck classBackGroundA' >
    <div className='deckRibbonRed'>
      { record.duelistAUserName + words.sDeck[state.language] }
    </div>
    <div className='flexRow justifyContentCenter widthMax'>
      <DeckInHistory record={record} side='A' popupLayer={props.popupLayer} />
    </div>
  </div>;

  const deckB =
  <div className='boxDeck classBackGroundB' >
    <div className='deckRibbonBlue'>
      { record.duelistBUserName + words.sDeck[state.language] }
    </div>
    <div className='flexRow justifyContentCenter widthMax'>
      <DeckInHistory record={record} side='B' popupLayer={props.popupLayer} />
    </div>
  </div>;

  const deckASP =
  <button className='flexColumn justifyContentSpaceAround alignItemsCenter button2 width96PC heightMin4 font0p7' disabled={props.disabled ? true : false}
    onClick={ () => {
      const body = {
        record: record,
        side: 'A',
        round: round,
      }

      const popup = { type: 'deckInHistorySP', body: body };
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer + 1], value: popup });
    }}
  >
    <div>
      { record.duelistAUserName }
    </div>
    <div>
      { words.sDeck[state.language] }
    </div>
  </button>

  const deckBSP =
  <button className='flexColumn justifyContentSpaceAround alignItemsCenter button2 width96PC heightMin4 font0p7' disabled={props.disabled ? true : false}
    onClick={ () => {
      const body = {
        record: record,
        side: 'B',
        round: round,
      }

      const popup = { type: 'deckInHistorySP', body: body };
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer + 1], value: popup });
    }}
  >
    <div>
      { record.duelistBUserName }
    </div>
    <div>
      { words.sDeck[state.language] }
    </div>
  </button>

  // ポイント

  const pointA = record.result
  .slice(0, round + 1)
  .reduce( (acc, cur) => {
    if (cur.winner === 'A') {
      return acc + 1;
    }
    else {
      return acc;
    }
  }, 0);

  const pointB = record.result
  .slice(0, round + 1)
  .reduce( (acc, cur) => {
    if (cur.winner === 'B') {
      return acc + 1;
    }
    else {
      return acc;
    }
  }, 0);

  // ボタン

  let nextButton;
  let backButton;
  let closeButton;
  let closeButtonSP;

  if (round <= record.round - 1) {
    nextButton =
    <button className='button2Resp pointerEventsAuto '
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'round'], value: round + 1 })
      }}
    >
      NEXT
    </button>
  }
  else {
    nextButton = <button className='button2Dummy' disabled={true} />;
  }

  if (round >= 1) {
    backButton =
    <button className='button2Resp pointerEventsAuto '
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'round'], value: round - 1 })
      }}
    >
      BACK
    </button>
  }
  else {
    backButton = <button className='button2Dummy' disabled={true} />;
  }

  if (state.getDuelHistory.action === 'duelHistorySingle') {
    closeButton =
    <button className='button2Resp'
      onClick={ () => {
        dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll'});
        handleClickGoBack(state, dispatch, navigate, location);
      }}
    >
      {/* TOP */}
      { words.back[state.language] }
    </button>;

    closeButtonSP =
    <button className='topRightClose z210 width4 focusEffect01'
      onClick={ () => {
        dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistoryAll'});
        handleClickGoBack(state, dispatch, navigate, location);
      }}
    >
      {/* [TOP] */}
      { `[${words.back[state.language]}]` }
    </button>;
  }
  else { // duelHistoryAll, duelHistoryAddress
    closeButton =
    <button className='button2Resp'
      onClick={ () => handleClickGoBack(state, dispatch, navigate, location) }
    >
      BACK TO LIST
    </button>;

    closeButtonSP =
    <button className='topRightClose z210 font2 focusEffect01'
      onClick={ () => handleClickGoBack(state, dispatch, navigate, location) }
    >
      ×
    </button>;
  }

  // -- シェアボタン

  const shareButton =
  <button className='button1'
    onClick={ () => {
      const popup = { type: 'generalItems', body: <Share record={record} /> };
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
    }}
  >
    <img className='size2x2' src={iconShare} alt='share' />
  </button>;

  // -- ヘッダ・フッタポジション切替ボタン

  const headerFooterPositionButton =
  <button className='button1'
    onClick={ () => {
      if (state.headerFooterPosition === 'fixed') {
        dispatch({ type: 'setState', key: 'headerFooterPosition', value: 'relative' });
      }
      else { // relative
        dispatch({ type: 'setState', key: 'headerFooterPosition', value: 'fixed' });
      }
    }}
  >
    <img className='size2x2' src={iconHeaderFooter} alt='switch header and footer position' />
  </button>;

  let monster = {};
  let monsterSP = {};
  let result = {};
  let magic = {};
  let magicSP = {};
  let knightBox = {};
  let knightBoxSP = {};

  const alternativeMonster = {
    A: 'emblemRed',
    B: 'emblemBlue',
  }

  const alternativeMagic = {
    A: 'imageMagicRed',
    B: 'imageMagicBlue',
  }

  const sideClass = {
    A: 'classA',
    B: 'classB',
  }

  const duelBattlePanelClass = {
    A: 'duelBattlePanelL',
    B: 'duelBattlePanelR',
  }

  const duelistUserName = {
    A: record.duelistAUserName,
    B: record.duelistBUserName,
  }

  for (const side of ['A', 'B']) {
    // 召喚ナイト

    monster[side] =
    <CardInHistory
      asset={ thisRound.monsters?.[side] }
      card={ thisRound.cards?.[side][thisRound.monstersIndex?.[side]] }
      popupLayer={props.popupLayer}
      alternative={alternativeMonster[side]}
      position='field'
      monstersInformationRevisedSingleSide={thisRound.monstersInformationRevised?.[side]}
      imageNoSingleSide={thisRound.imageNo?.[side]}
    />;

    monsterSP[side] =
    <CardInHistory
      asset={ thisRound.monsters?.[side] }
      card={ thisRound.cards?.[side][thisRound.monstersIndex?.[side]] }
      popupLayer={props.popupLayer}
      alternative={alternativeMonster[side]}
      position='field'
      monstersInformationRevisedSingleSide={thisRound.monstersInformationRevised?.[side]}
      imageNoSingleSide={thisRound.imageNo?.[side]}
      device='SP'
    />;

    // バトル結果

    if (thisRound.winner === side) {
      result[side] =
      <div className='flexRow justifyContentCenter widthMax' >
        <img className='width44PC ' src={logoWin} alt='win' />
      </div>
    }
    else if (thisRound.winner === otherSide(side)) {
      result[side] =
      <div className='flexRow justifyContentCenter widthMax' >
        <img className='width44PC ' src={logoLose} alt='lose' />
      </div>
    }
    else if (thisRound.winner === 'draw') {
      result[side] =
      <div className='flexRow justifyContentCenter widthMax' >
        <img className='width44PC ' src={logoDraw} alt='draw' />
      </div>
    }
    else {
      result[side] = null;
    }

    // 詠唱魔法

    magic[side] =
    <CardInHistory
      asset={ thisRound.magics?.[side]?.[0]?.asset }
      index={ thisRound.magics?.[side]?.[0]?.index }
      card={ thisRound.cards?.[side][thisRound.magics?.[side]?.[0]?.index] }
      alternative={ alternativeMagic[side] }
      position='cast'
      size='small'
      popupLayer={props.popupLayer}
    />;

    magicSP[side] =
    <CardInHistory
      asset={ thisRound.magics?.[side]?.[0]?.asset }
      index={ thisRound.magics?.[side]?.[0]?.index }
      card={ thisRound.cards?.[side][thisRound.magics?.[side]?.[0]?.index] }
      alternative={ alternativeMagic[side] }
      device='SP'
      position='cast'
      size='small'
      popupLayer={props.popupLayer}
    />;

    if (record.difficultyMode === 'simple' || record.difficultyMode === undefined) {
      knightBox[side] =
      <div className={'flexColumn margin0p5 ' + duelBattlePanelClass[side] + ' ' + sideClass[side]} >
        <div className='heightMin1p3 margin0p5' >
          { duelistUserName[side] }
        </div>
        <div className='knightBox '>
          { monster[side] }
          { result[side] }
        </div>
      </div>;

      knightBoxSP[side] =
      <div className={'knightBox widthKnightBoxSP heightKnightBoxSP ' + duelBattlePanelClass[side] + ' ' + sideClass[side]} >
        <div className='heightMin1p3 font0p7' >
          { duelistUserName[side] }
        </div>
        { monsterSP[side] }
      </div>
    }
    else { // advanced SPの場合対称だから。
      knightBoxSP[side] =
      <div className={'knightBox widthKnightBoxSP heightKnightBoxSP ' + duelBattlePanelClass[side] + ' ' + sideClass[side]} >
        <div className='heightMin1p3 font0p7' >
          { duelistUserName[side] }
        </div>
        { monsterSP[side] }
        <div className='flexRow justifyContentFlexStart alignItemsCenter margin0p5'> 
          { magicSP[side] }
          <div className='flexColumn justifyContentFlexStart alignItemsCenter '>
            <MaginaPointInHistory side={side} thisRound={thisRound} baseClass='padding0p3 font0p7' initiativeClass={'borderFat borderRadius0p5 ' + borderColor(side)} />
            <MaginaPointAppliedInHistory side={side} thisRound={thisRound} device='SP' />
            <TargetIndicationInHistory side={side} thisRound={thisRound} textClass='font0p5' />
          </div>
        </div> 
      </div>
    }
  }

  // KNIGHT BOX ADVANCED
  // ナイトボックス(アドバンスト)
  // 非対称だから、ループの外で定義。

  if (record.difficultyMode === 'advanced') {
    knightBox.A =
    <div className={'flexColumn margin0p5 duelBattlePanelL classA' } >
      <div className='heightMin1p3 margin0p5' >
        { duelistUserName.A }
      </div>
      <div className='flexRow justifyContentCenter ' >
        <div className='flexColumn justifyContentCenter alignItemsCenter width3 marginTop0p5 padding0p5 ' >
          <MaginaGaugeInHistory magic={thisRound.magics?.A[0]} maginaPoint={thisRound.maginaPoint} />
          <div className='margin0p5' >
            <MaginaPointAppliedInHistory side='A' thisRound={thisRound} />
          </div>
        </div>
        <div className='flexColumn justifyContentFlexStart alignItemsCenter' >
          <div className='flexColumn justifyContentFlexStart alignItemsCenter width11 marginTop0p5 padding0p5 ' >
            <MaginaPointInHistory side='A' thisRound={thisRound} baseClass='padding0p5' initiativeClass='borderFat borderRadius0p5 borderColorA' />
            <div className='flexColumn justifyContentFlexStart alignItemsCenter marginTop1'> 
              { magic.A }
              <TargetIndicationInHistory side='A' thisRound={thisRound} />
            </div> 
          </div>
        </div>
        <div className='knightBox '>
          { monster.A }
          { result.A }
        </div>
      </div>
    </div>;

    knightBox.B =
    <div className={'flexColumn margin0p5 duelBattlePanelR classB' } >
      <div className='heightMin1p3 margin0p5' >
        { duelistUserName.B }
      </div>
      <div className='flexRow justifyContentCenter ' >
        <div className='knightBox '>
          { monster.B }
          { result.B }
        </div>
        <div className='flexColumn justifyContentFlexStart alignItemsCenter' >
          <div className='flexColumn justifyContentFlexStart alignItemsCenter width11 marginTop0p5 padding0p5 ' >
            <MaginaPointInHistory side='B' thisRound={thisRound} baseClass='padding0p5' initiativeClass='borderFat borderRadius0p5 borderColorB' />
            <div className='flexColumn justifyContentFlexStart alignItemsCenter marginTop1'> 
              { magic.B }
              <TargetIndicationInHistory side='B' thisRound={thisRound} />
            </div> 
          </div>
        </div>
        <div className='flexColumn justifyContentCenter alignItemsCenter width3 marginTop0p5 padding0p5 ' >
          <MaginaGaugeInHistory magic={thisRound.magics?.B[0]} maginaPoint={thisRound.maginaPoint} />
          <div className='margin0p5' >
            <MaginaPointAppliedInHistory side='B' thisRound={thisRound} />
          </div>
        </div>
      </div>
    </div>;
  }

  // デュエルの結果・決着の理由

  let duelResult;
  let reason;

  if (round === record.round) {
    if (record.duelWinner === 'draw') {
      duelResult =
      <div className='flexRow justifyContentCenter alignItemsCenter font2 marginSide0p5'>
        { words.draw[state.language] }
      </div>
    }
    else {
      duelResult =
      <div className='flexRow justifyContentCenter alignItemsCenter font2 marginSide0p5'>
        { words[record.duelWinner][state.language] + words.win2[state.language] }
      </div>
    }

    if (record.result[round].reason === 'timeUp') {
      reason =
      <div className='flexRow justifyContentCenter alignItemsCenter marginSide1'>
        { `(${words.timeup[state.language]})` }
      </div>
    }
    else if (record.result[round].reason === 'leave') {
      reason =
      <div className='flexRow justifyContentCenter alignItemsCenter marginSide1'>
        { `(${words.leftTheGame[state.language]})` }
      </div>
    }
    else { // normal, additionalJudgement
      reason = null
    }
  }
  else {
    duelResult = null;
    reason = null
  }

  // ヘッダ・フッタ

  let headerFixed;
  let headerRelative;
  let footerFixed;
  let footerRelative;
  let headerFixedPc;
  let headerRelativePc;

  const headerCore =
  <div className='flexColumn alignItemsCenter relative widthMax '>
    { closeButtonSP }
    <div className='font0p5 marginTopBottom0p5'>
      { record.roomId + '-' + record.duelNo }
    </div>
    <div className='flexRow justifyContentSpaceBetween widthMax marginTop0p5 '>
      <div className='flexRow justifyContentCenter alignItemsCenter font2 marginSide0p5'>
        { 'round ' + round }
      </div>
      { duelResult }
      { reason }
    </div>
    <div className='flexRow justifyContentCenter widthMax'>
      <div className='flexRow justifyContentFlexEnd alignItemsCenter width40PC marginSide1 '>
        <Score src={roseRed} point={pointA} />
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter width40PC marginSide1 '>
        <Score src={roseBlue} point={pointB} />
      </div>
    </div>
  </div>;

  const footerCore =
  <div className='flexColumn alignItemsCenter widthMax '>
    <div className='flexRow justifyContentSpaceBetween widthMax '>
      <div className='flexRow justifyContentCenter alignItemsCenter width48vw '>
        { backButton }
      </div>
      <div className='flexRow justifyContentCenter alignItemsCenter width48vw '>
        { nextButton }
      </div>
    </div>
    <div className='flexRow justifyContentSpaceBetween widthMax '>
      <div className='flexRow justifyContentCenter alignItemsCenter width48vw pointerEventsAuto '>
        { deckASP }
      </div>
      <div className='flexRow justifyContentCenter alignItemsCenter width48vw pointerEventsAuto '>
        { deckBSP }
      </div>
    </div>
  </div>;

  const headerCorePc =
  <div className='flexRow justifyContentSpaceBetween widthMax '>
    <div className='flexRow justifyContentFlexStart widthMin10 '>
      { backButton }
      { nextButton }
    </div>
    <div className='flexRow justifyContentCenter'>
      <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMin10 marginSide1 '>
        <Score src={roseRed} point={pointA} />
      </div>
      <div className='flexRow '>
        <div className='flexRow justifyContentCenter alignItemsCenter font2 marginSide0p5'>
          { 'round ' + round }
        </div>
        { duelResult }
        { reason }
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter widthMin10 marginSide1 '>
        <Score src={roseBlue} point={pointB} />
      </div>
    </div>
    <div className='flexRow justifyContentFlexEnd alignItemsFlexEnd widthMin10 '>
      <div className='font0p5 marginTopBottom0p5 marginSide1'>
        { record.roomId + '-' + record.duelNo }
      </div>
      { headerFooterPositionButton }
      <div className='marginSide0p5'>
        { shareButton }
      </div>
      { closeButton }
    </div>
  </div>;

  if (state.headerFooterPosition === 'fixed') {
    headerFixed =
    <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
      { headerCore }
    </div>;

    footerFixed =
    <div className='z200FixedBottom widthMax pointerEventsNone '>
      { footerCore }
    </div>;

    headerFixedPc =
    <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
      { headerCorePc }
    </div>;

    headerRelative =
    <div className='widthMax height8 ' >
    </div>;

    footerRelative =
    <div className='widthMax height9 ' >
    </div>;

    headerRelativePc =
    <div className='widthMax height6 ' >
    </div>;
  }
  else { // relative
    headerRelative = headerCore;
    footerRelative = footerCore;
    headerRelativePc = headerCorePc;
  }


  return (
    <div className='widthMax'>
      {/* PC */}
      <div className="visibleHuge flexColumn alignItemsCenter duelMainScreenBackground">
        <div className="relative ">
          { headerRelativePc }
          <div className='flexColumn alignItemsCenter ' >
            { deckB }
            <div className='flexRow duelField justifyContentSpaceAround alignItemsStretch'>
              { knightBox.A }
              <div className='duelTextBattlePanel'>
                <DuelTextInHistory record={record} />
                {/* duelUpEffect */}
              </div>
              { knightBox.B }
            </div>
            { deckA }
          </div>
          {/* development */}
          {/* process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null */}
        </div>
        { headerFixedPc }
      </div>
      {/* TABLET */}
      <div className="visibleLarge duelMainScreenBackground">
        <div className="flexColumn alignItemsCenter ">
          <div className='flexColumn alignItemsCenter ' >
            { deckB }
            <div className='flexRow justifyContentSpaceBetween widthMax '>
              <div className='flexRow justifyContentFlexStart widthMin10 '>
                { backButton }
                { nextButton }
              </div>
              <div className='flexRow justifyContentCenter'>
                <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMin10 marginSide1 '>
                  <Score src={roseRed} point={pointA} />
                </div>
                <div className='flexRow '>
                  <div className='flexRow justifyContentCenter alignItemsCenter font2 marginSide0p5'>
                    { 'round ' + round }
                  </div>
                  { duelResult }
                  { reason }
                </div>
                <div className='flexRow justifyContentFlexStart alignItemsCenter widthMin10 marginSide1 '>
                  <Score src={roseBlue} point={pointB} />
                </div>
              </div>
              <div className='flexRow justifyContentFlexEnd alignItemsFlexEnd widthMin10 '>
                <div className='font0p5 marginTopBottom0p5 marginSide1'>
                  { record.roomId + '-' + record.duelNo }
                </div>
                <div className='marginSide0p5'>
                  { shareButton }
                </div>
                { closeButton }
              </div>
            </div>
            <div className='duelField flexColumn justifyContentFlexStart alignItemsCenter'>
              <div className='flexRow justifyContentSpaceAround alignItemsCenter' >
                { knightBox.A }
                { knightBox.B }
              </div>
              <DuelTextInHistory record={record} fontSizeClass='font1p5' />
            </div>
            { deckA }
          </div>
          {/* development */}
          {/* process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null */}
        </div>
      </div>
      {/* SP */}
      {/* <div className="flexColumn alignItemsCenter widthMax paddingBottom1 visibleMiddleOrLess "> */}
      <div className="visibleMiddleOrLess relative widthMax overflowXHidden duelMainScreenBackground ">
        <div className="flexColumn alignItemsCenter widthMax ">
          { headerRelative }
          <div className='duelField duelFieldSP flexColumn alignItemsCenter'>
            <div className='flexRow justifyContentSpaceAround alignItemsFlexStart widthMax'>
              { knightBoxSP.A }
              { knightBoxSP.B }
            </div>
            <div className='flexRow justifyContentCenter alignItemsCenter widthMax'>
              <div className='flexRow justifyContentCenter alignItemsCenter width48vw'>
                { result.A }
              </div>
              <div className='flexRow justifyContentCenter alignItemsCenter width48vw'>
                { result.B }
              </div>
            </div>
            <div >
              <DuelTextInHistory record={record} fontSizeClass='' />
            </div>
          </div>
          <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax'>
            <div className='pointerEventsAuto '>
              { headerFooterPositionButton }
            </div>
            <div className='pointerEventsAuto '>
              { shareButton }
            </div>
          </div>
          { footerRelative }
        </div>
        { headerFixed }
        { footerFixed }
      </div>
    </div>
  );


}

// DUEL HISTORY DETAIL FULL SCREEN
function DuelHistoryDetailFullScreen() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const urlParams = (new URL(document.location)).searchParams;
  const roomId = urlParams.get('roomid') === null ? null : urlParams.get('roomid');
  const duelNo = urlParams.get('duelno') === null ? null : parseInt(urlParams.get('duelno'), 10);
  const round = urlParams.get('round') === null ? 0 : parseInt(urlParams.get('round'), 10);

  useEffect( () => {
    const func = async () => {
      devLog('A', roomId, duelNo);
      if (roomId !== null && duelNo !== null) {
        devLog('B', roomId, duelNo);
        dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'action'], value: 'duelHistorySingle'});
        dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'roomId'], value: roomId});
        dispatch({type: 'setStateMultiLayers', keys: ['getDuelHistory', 'duelNo'], value: duelNo});
        const response = await handleClickGetDuelHistoryAll(state, dispatch, 0, { action: 'duelHistorySingle', roomId: roomId, duelNo: duelNo });

        const popup = { type: 'duelHistoryDetail', body: response.body.duelHistory };
        dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'round'], value: round });
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 100], value: popup });
      }
      else if (state.popup[100].type !== null) {
        // 特になにもしない。
        devLog('C', roomId, duelNo);
      }
      else {
        devLog('D', roomId, duelNo);
        navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/top' : '/top');
      }
    }

    func();
    devLog('E', roomId, duelNo);
  }, []);

  let content;

  if (state.popup[100]?.type === 'duelHistoryDetail' && Object.keys(state.registeredCard).length >= 1) {
    content = <DuelHistoryDetail popupLayer={100} />;
  }
  else {
    content = null;
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        { content }
      </div>
      {/* SP */}
      <div className="flexColumn alignItemsCenter widthMax visibleSmallOrLess ">
        { content }
      </div>
    </div>
  );
}

// MAGINA POINT IN HISTORY
function MaginaPointInHistory(props) {
  const side = props.side;
  const thisRound = props.thisRound;
  const baseClass = props.baseClass;
  const initiativeClass = props.initiativeClass;

  let maginaPoint;
  let additionalClass;

  if (thisRound.maginaPoint?.[side] !== undefined) {
    if (thisRound.initiativeNext === side) {
      additionalClass = initiativeClass;
    }
    else if (thisRound.initiativeNext === 'coinToss') {
      additionalClass = '';
    }
    else {
      additionalClass = '';
    }

    maginaPoint =
    <div className={ baseClass + ' ' + additionalClass } > 
      { 'MP ' + thisRound.maginaPoint[side] }
    </div> 
  }

  return maginaPoint;
}

// SHARE
function Share(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const record = props.record;
  const roomId = record.roomId;
  const duelNo = record.duelNo;

  const urlFromTheBeginning = 'https://' + process.env.REACT_APP_KOM_EXTENSION_URL + `duelhistorydetail?roomid=${roomId}&duelno=${duelNo}`;
  const urlThisRound = 'https://' + process.env.REACT_APP_KOM_EXTENSION_URL + `duelhistorydetail?roomid=${roomId}&duelno=${duelNo}&round=${state.getDuelHistory.round}`;

  const title = ''
  const hashtags = ['KnightsOfMonadom', 'モナダム'];

  const textAreaRef = useRef(null);

  const fromTheBeginning =
  <div className='flexColumn alignItemsCenter borderKOM padding1' >
    <div className='margin0p5 textCenter' >
      <div>{words.url[state.language]}</div>
      <div>{words.fromTheBeginning[state.language]}</div>
    </div>
    <div className='flexRow justifyContentCenter' >
      <div className='margin1' >
        <TwitterShareButton
          url={urlFromTheBeginning}
          title={title}
          hashtags={hashtags}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </div>
      <button className='button1 margin1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText(urlFromTheBeginning)
          .then()
          .catch( err => {
            copyToClipboard(urlFromTheBeginning, textAreaRef);
          });
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy' />
      </button>
      <textarea ref={textAreaRef} style={{ position: 'absolute', left: '-9999px' }} ></textarea>
    </div>
  </div>;

  const thisRound =
  <div className='flexColumn alignItemsCenter borderKOM padding1' >
    <div className='margin0p5 textCenter' >
      <div>{words.url[state.language]}</div>
      <div>{words.thisRound[state.language]}</div>
    </div>
    <div className='flexRow justifyContentCenter' >
      <div className='margin1' >
        <TwitterShareButton
          url={urlThisRound}
          title={title}
          hashtags={hashtags}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </div>
      <button className='button1 margin1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText(urlThisRound)
          .then()
          .catch( err => {
            copyToClipboard(urlThisRound, textAreaRef);
          });
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy' />
      </button>
      <textarea ref={textAreaRef} style={{ position: 'absolute', left: '-9999px' }} ></textarea>
    </div>
  </div>;

  const battleStory =
  <div className='flexColumn alignItemsCenter borderKOM padding1' >
    <div className='margin0p5' >
      {words.story[state.language]}
    </div>
    <div className='flexRow justifyContentCenter' >
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          copyDuelHistoryStoryToClipboard({
            dispatch,
            language: state.language,
            registeredCard: state.registeredCard,
            thisRound: record.result[state.getDuelHistory.round],
            textAreaRef,
          });
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy story' />
      </button>
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          downloadDuelHistoryStoryImage({
            dispatch,
            language: state.language,
            registeredCard: state.registeredCard,
            thisRound: record.result[state.getDuelHistory.round],
          });
        }}
      >
        <img className='size2x2' src={iconDownload} alt='download story' />
      </button>
    </div>
  </div>;

  const knightBoxesImage =
  <div className='flexColumn alignItemsCenter borderKOM padding1' >
    <div className='margin0p5' >
      {words.knightAndMagic[state.language]}
    </div>
    <div className='flexRow justifyContentCenter' >
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          copyDuelHistoryKnightBoxesToClipboard({
            dispatch,
            language: state.language,
            record,
            registeredCard: state.registeredCard,
            round: state.getDuelHistory.round,
            textAreaRef,
          });
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy knight boxes' />
      </button>
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          downloadDuelHistoryKnightBoxesImage({
            dispatch,
            language: state.language,
            record,
            registeredCard: state.registeredCard,
            round: state.getDuelHistory.round,
          });
        }}
      >
        <img className='size2x2' src={iconDownload} alt='download knight boxes' />
      </button>
    </div>
  </div>;

  return (
    <div className='flexColumn alignItemsCenter' >
      {/* PC */}
      <div className="visibleMiddleOrMore flexRow">
        <div className="margin1 ">
          { fromTheBeginning }
        </div>
        <div className="margin1 ">
          { thisRound }
        </div>
        <div className="margin1 ">
          { battleStory }
        </div>
        <div className="margin1 ">
          { knightBoxesImage }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn">
        <div className="margin1 ">
          { fromTheBeginning }
        </div>
        <div className="margin1 ">
          { thisRound }
        </div>
        <div className="margin1 ">
          { battleStory }
        </div>
        <div className="margin1 ">
          { knightBoxesImage }
        </div>
      </div>
    </div>
  );
}

// MAGINA POINT APPLIED IN HISTORY
function MaginaPointAppliedInHistory(props) {
  const side = props.side;
  const thisRound = props.thisRound;
  const device = props.device;
  const magic = thisRound.magics?.[side]?.[0];
  const maginaPoint = thisRound.maginaPoint;

  let maginaPointApplied;

  if (magic !== undefined && maginaPoint.applied !== undefined) {
    if (device === 'SP') {
      maginaPointApplied =
      <div className={ 'padding0p3 font0p7 borderThin borderRadius0p5 ' + borderColor(maginaPoint.applied.side) } > 
        { '<< ' + maginaPoint.applied.point }
      </div> 
    }
    else { // PC
      maginaPointApplied =
      <div className={ 'padding0p5 borderThin borderRadius0p5 ' + borderColor(maginaPoint.applied.side) } > 
        { maginaPoint.applied.point }
      </div> 
    }
  }

  return maginaPointApplied;
}

// MAGINA GAUGE IN HISTORY
function MaginaGaugeInHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const magic = props.magic;
  const maginaPoint = props.maginaPoint;
  const direction = props.direction;
  const noMagic = props.noMagic;

  const backgroundColorClass = {
    A: 'classBackGroundA',
    B: 'classBackGroundB',
  };

  let maginaGauge;

  // if (state.duel.maginaPoint.applied !== undefined && state.duel.maginaPoint.applied !== null) {
  //   maginaPoint = state.duel.maginaPoint.applied;
  // }
  // else {
  //   maginaPoint = state.duel.maginaPoint[side];
  // }

  if (magic !== undefined) {
    const maginaThresholds = state.registeredCard[magic.asset].maginaThresholds;
    const thresholdsWithBox = maginaThresholds.map( threshold => {
      return {
        upperBound: threshold.upperBound,
        face: threshold.face,
        box: [],
      };
    });

    for (const threshold of thresholdsWithBox) {
      if (maginaPoint.applied?.point < threshold.upperBound) {
        threshold.box.push({ side: maginaPoint.applied.side, point: maginaPoint.applied.point })
        break;
      }
    }

    if (direction === 'horizontal') {
      maginaGauge =
      <div className='flexRow alignItemsCenter borderMonacotto padding0p3' >
        <div className='textCenter height1p6 font0p7' >
          { '0' }
        </div>
        {
          thresholdsWithBox.map( threshold =>
              <div className='flexRowReverse justifyContentCenter alignItemsCenter ' >
                <div className='textCenter height1p6 font0p7' >
                  { threshold.face !== undefined ? threshold.face : threshold.upperBound }
                </div>
                <div className='flexColumn justifyContentCenter alignItemsCenter width1 height1p6' >
                  {
                    threshold.box.map( ball => 
                      <div className={'width0p7 height0p7 borderRadiusCircle ' + backgroundColorClass[ball.side]} >
                      </div>
                    )
                  }
                </div>
              </div>
          )
        }
      </div>;
    }
    else { // vertical
      maginaGauge =
      <div className='flexColumnReverse alignItemsCenter borderMonacotto' >
        <div className='textCenter width2p4 height1p2' >
          { '0' }
        </div>
        {
          thresholdsWithBox.map( threshold =>
              <div className='flexColumn justifyContentCenter alignItemsCenter ' >
                <div className='textCenter width2p4 height1p2' >
                  { threshold.face !== undefined ? threshold.face : threshold.upperBound }
                </div>
                <div className='flexRow justifyContentCenter alignItemsCenter width2p4 height1p2' >
                  {
                    threshold.box.map( ball => 
                      <div className={'width1 height1 borderRadiusCircle ' + backgroundColorClass[ball.side]} >
                      </div>
                    )
                  }
                </div>
              </div>
          )
        }
      </div>;
    }

    // return (
    //   <div className='flexColumnReverse alignItemsCenter borderMonacotto' >
    //     <div className='textCenter width2p4 height1p2' >
    //       { '0' }
    //     </div>
    //     {
    //       thresholdsWithBox.map( threshold =>
    //           <div className='flexColumn justifyContentCenter alignItemsCenter ' >
    //             <div className='textCenter width2p4 height1p2' >
    //               { threshold.face !== undefined ? threshold.face : threshold.upperBound }
    //             </div>
    //             <div className='flexRow justifyContentCenter alignItemsCenter width2p4 height1p2' >
    //               {
    //                 threshold.box.map( ball => 
    //                   <div className={'width1 height1 borderRadiusCircle ' + backgroundColorClass[ball.side]} >
    //                   </div>
    //                 )
    //               }
    //             </div>
    //           </div>
    //       )
    //     }
    //   </div>
    // );
  }
  // else {
  //   return (
  //     <div className='flexColumnReverse alignItemsCenter borderMonacotto' >
  //     </div>
  //   );
  // }
  else {
    if (noMagic === 'blank') {
      maginaGauge = null;
    }
    else {
      maginaGauge =
      <div className='flexColumnReverse alignItemsCenter borderMonacotto' >
      </div>;
    }
  }

  return maginaGauge;
}

// TARGET INDICATION IN HISTORY
function TargetIndicationInHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const side = props.side;
  const thisRound = props.thisRound;
  const textClass = props.textClass;
  const targets = thisRound.magics?.[side]?.[0]?.targets;

  let targetIndication;

  if (targets !== undefined) {
    const targetsReduced = targets.reduce( (acc, cur) =>
      acc + Object.keys(cur).reduce( (acc2, cur2) => {
        if (cur[cur2].side !== undefined && cur[cur2].side !== null) {
          return `${acc2}${words[cur[cur2].side][state.language]} `
        }
        else {
          return acc;
        }
      }, ''),
    '');

    if (targetsReduced !== '') {
      targetIndication =
      <div className={'borderKOM borderRadius0p3 margin0p5 padding0p5 ' + textClass} >
        { targetsReduced }
      </div>;
    }
  }

  return targetIndication;
}

// DECK IN HISTORY
function DeckInHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const record = props.record;
  const side = props.side;
  const round = state.getDuelHistory.round;
  const thisRound = record.result[round];

  let deck;
  let otherSide;

  if (side === 'A') {
    deck = record.duelistADeck;
    otherSide = 'B';
  }
  else { // B
    deck = record.duelistBDeck;
    otherSide = 'A';
  }

  const losingMonsters = record.result
  .filter( (round, index) => round.winner === otherSide && index <= state.getDuelHistory.round ) // drawは除外される。
  .map( round => round.monstersIndex[side] );

  const cards = deck?.cards.map ( (card, index) =>
    <CardInHistory
      asset={card.asset}
      index={index}
      card={thisRound.cards?.[side][index]}
      losing={losingMonsters.includes(index)}
      magics={thisRound.magics}
      difficultyMode={record.difficultyMode}
      size='small'
      popupLayer={props.popupLayer}
    />
  );

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexRow flexWrapNoWrap maxWidth97vw scrollXAuto '>
          { cards.map( card => <div className='width11 ' >{ card }</div> ) }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess">
        <div className='flexRow'>
          { cards }
        </div>
      </div>
    </div>
  );
}

// DECK IN HISTORY SP type: deckInHistorySP
function DeckInHistorySP(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const popupLayer = props.popupLayer;
  const record = state.popup[popupLayer].body.record;
  const side = state.popup[popupLayer].body.side;
  const round = state.popup[popupLayer].body.round;
  const thisRound = record.result[round];

  let deck;
  let otherSide;
  let thisSideBackGround;
  let thisSideAlternativeMagic;

  if (side === 'A') {
    deck = record.duelistADeck;
    otherSide = 'B';
    thisSideBackGround = 'classBackGroundA';
    thisSideAlternativeMagic = 'imageMagicRed';
  }
  else { // B
    deck = record.duelistBDeck;
    otherSide = 'A';
    thisSideBackGround = 'classBackGroundB';
    thisSideAlternativeMagic = 'imageMagicBlue';
  }

  const losingMonsters = record.result
  .filter( (round, index) => round.winner === otherSide && index <= state.getDuelHistory.round ) // drawは除外される。
  .map( round => round.monstersIndex[side] );

  const thisSideMagic =
  <CardInHistory
    asset={ thisRound.magics?.[side]?.[0]?.asset }
    index={ thisRound.magics?.[side]?.[0]?.index }
    card={thisRound.cards?.[side][thisRound.magics?.[side]?.[0]?.index]}
    alternative={thisSideAlternativeMagic} 
    device='SP'
    size='small'
    position='cast'
    popupLayer={popupLayer}
  />;

  const cards = deck?.cards.map ( (card, index) =>
    <CardInHistory
      asset={card.asset}
      index={index}
      card={thisRound.cards?.[side][index]}
      losing={losingMonsters.includes(index)}
      magics={thisRound.magics}
      difficultyMode={record.difficultyMode}
      device='SP'
      size='small'
      popupLayer={popupLayer}
    />
  );

  let magicInformation;

  if (record.difficultyMode === 'advanced') {
    magicInformation =
    <>
      <div className='flexRow justifyContentCenter alignItemsCenter widthMax ' >
        { thisSideMagic }
        <div className='flexColumn justifyContentFlexStart alignItemsCenter marginSide0p5' >
          <MaginaPointInHistory side={side} thisRound={thisRound} baseClass='padding0p5' initiativeClass={'borderFat borderRadius0p5 ' + borderColor(side)} />
          <TargetIndicationInHistory side={side} thisRound={thisRound} textClass='font0p5' />
        </div>
      </div>
      <div className='marginSide1 marginTop0p5' >
        <MaginaGaugeInHistory magic={thisRound.magics?.[side]?.[0]} maginaPoint={thisRound.maginaPoint} direction='horizontal' noMagic='blank' />
      </div>
    </>;
  }
  else {
    magicInformation = null;
  }


  return (
    <div className='visibleSmallOrLess'>
      <div className={'deckPopup flexColumn alignItemsFlexStart marginTop0p5 ' + thisSideBackGround} >
        { magicInformation }
        <div className='flexRow justifyContentSpaceAround alignItemsCenter marginTop0p5 ' >
          { cards }
        </div>
        <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax marginTop0p5' >
          <button className='button2' onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } }) } >
            { words.close[state.language] }
          </button>
        </div>
      </div>
    </div>
  );
}

// CARD IN HISTORY
function CardInHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const asset = props.asset;
  const index = props.index;
  const monstersInformationRevisedSingleSide = props.monstersInformationRevisedSingleSide;
  const imageNoSingleSide = props.imageNoSingleSide;
  const card = props.card;
  const losing = props.losing;
  const magics = props.magics;
  const difficultyMode = props.difficultyMode;
  const alternative = props.alternative;
  const position = props.position;
  const device = props.device;
  const size = props.size;
  const popupLayer = props.popupLayer;

  // スタイル

  let styleBox;
  let styleCard;
  let emblemContainerHeight;
  let alternativeMargin;

  if (device === 'SP') {
    if (size === 'small') {
      styleBox = 'boxCardSP';
      styleCard = 'cardImageSmallSP';
    }
    else {
      styleBox = 'boxCardSP';
      styleCard = 'cardImageSP';
      emblemContainerHeight = 'heightEmblemSP';
    }
  }
  else {
    if (size === 'small') {
      styleBox = 'boxCardSmall';
      styleCard = 'cardImageSmall';
      alternativeMargin = 'marginTop4';
    }
    else {
      styleBox = 'boxCard';
      styleCard = 'cardImage';
      emblemContainerHeight = 'height27';
    }
  }

  let styleBoxColor = '';
  let styleBorderColor = '';
  let styleBoxPadding = '';

  if (asset !== undefined) {
    if (position !== 'cast' && position !== 'field') {
      if (state.registeredCard[asset].category === 'magic') {
        styleBoxColor = ' backgroundColorLightGreen';
        styleBorderColor = ' borderDeepGreenFat';

        if (device === 'SP') {
          styleBoxPadding = ' padding0p5';
        }
      }
      else if (state.registeredCard[asset].category !== 'magic') {
        if (device === 'SP') {
          styleBoxPadding = ' padding0p5';
        }
      }
      else {
      }
    }
    else {
    }
  }
  else {
  }

  styleBox += styleBoxColor + styleBorderColor + styleBoxPadding;

  // カードイメージ

  let cardImageUrl;
  let cardName;
  let cardImage;
  let cardStatus;
  let cardStatusImage;
  let screen;
  let targetIndication;

  if (asset === undefined) {
    if (alternative === 'emblemRed') {
      cardImage =
      <div className={'flexColumn justifyContentCenter ' + emblemContainerHeight} >
        <img className={styleCard} src={emblemRed} alt='emblemRed' />
      </div>
    }
    else if (alternative === 'emblemBlue') {
      cardImage =
      <div className={'flexColumn justifyContentCenter ' + emblemContainerHeight} >
        <img className={styleCard} src={emblemBlue} alt='emblemBlue' />
      </div>
    }
    else if (alternative === 'imageMagicRed') {
      cardImage =
      <button className={'flexColumn justifyContentCenter backgroundColorTransparent borderNone ' + alternativeMargin} disabled={true} >
        <img className={styleCard} src={imageMagicRed} alt='imageMagicRed' />
      </button>
    }
    else if (alternative === 'imageMagicBlue') {
      cardImage =
      <button className={'flexColumn justifyContentCenter backgroundColorTransparent borderNone ' + alternativeMargin} disabled={true} >
        <img className={styleCard} src={imageMagicBlue} alt='imageMagicBlue' />
      </button>
    }
    else {
      return null;
    }
  }
  else {
    // カードステータス

    if (card !== undefined) {
      cardStatus = card.status; // assetがあればindexもあるからcardもある。とは限らない！魔法以前のデータにはcardは無い！

      if (position === 'field') {
        cardStatusImage = null;
        screen = null;
      }
      else if (position === 'cast') {
        cardStatusImage = null;
        screen = null;
      }
      else if (cardStatus === 'cemetery') {
        cardStatusImage =
        <div className='monsterStatus width75PC '>
          <img className='width70P' src={imageCemetery} alt='cemetery' />
        </div>

        screen =
        <div className='screen140'>
        </div>;
      }
      else if (cardStatus === 'anotherDimension') {
        cardStatusImage =
        <div className='monsterStatus width75PC '>
          <img className='width70P' src={imageAnotherDimension} alt='anotherDimension' />
        </div>

        screen =
        <div className='screen140'>
        </div>;
      }
      else {
        cardStatusImage = null;
        screen = null;
      }
    }
    else if (losing === true) {
      cardStatusImage =
      <div className='monsterStatus width75PC '>
        <img className='widthMax' src={logoLose} alt='lose' />
      </div>

      screen =
      <div className='screen140'>
      </div>;
    }
    else {
      cardStatusImage = null;
      screen = null;
    }

    // 対象表示

    if (difficultyMode === 'advanced') {
      if (magics !== undefined) {
        OUTERMOST: for (const sideInLoop of ['A', 'B']) {
          for (const magic of magics[sideInLoop]) {
            if (magic.targets !== undefined) {
              for (const targetOfAPreEffect of magic.targets) {
                for (const targetKey of Object.keys(targetOfAPreEffect)) {
                  if (targetOfAPreEffect[targetKey].cards !== undefined) {
                    for (const card of targetOfAPreEffect[targetKey].cards) {
                      if (card.index === index) {
                        targetIndication =
                        <div className='target width75PC '>
                          <img className='width70P' src={imageTarget} alt='target' />
                        </div>;

                        break OUTERMOST;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    // カードイメージURL

    if (position === 'field' && imageNoSingleSide !== undefined && imageNoSingleSide !== 0) {
      if (device === 'SP') {
        cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}small/${asset}_${imageNoSingleSide}_small.png`;
      }
      else {
        cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}${asset}_${imageNoSingleSide}.png`;
      }
    }
    else {
      if (device === 'SP') {
        cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}small/${asset}_small.png`;
      }
      else {
        cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}${asset}.png`;
      }
    }

    // if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    //   if (device === 'SP') {
    //     cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/small/${asset}_small.png`;
    //   }
    //   else {
    //     cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/${asset}.png`;
    //   }
    // }
    // else { // dev
    //   if (device === 'SP') {
    //     cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/small/${asset}_small.png`;
    //   }
    //   else {
    //     cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/${asset}.png`;
    //   }
    // }

    // カードネーム

    if (device === 'SP') {
      // if (state.registeredCard[asset].category === 'magic' && position !== 'cast') {
      //   cardName =
      //   <div className='widthMax borderNone borderRadius2 padding0p3 backgroundColorMagic' >
      //   </div>
      // }
      // else {
      //   cardName = null;
      // }

      cardName = null;
    }
    else {
      if (position === 'field' && monstersInformationRevisedSingleSide?.name !== undefined) {
        cardName =
        <div className='borderNone borderRadius2 padding0p3 marginTop0p5 ' >
          { monstersInformationRevisedSingleSide?.name }
        </div>
      }
      else if (state.registeredCard[asset].category === 'magic' && position !== 'cast') {
        cardName =
        // <div className='borderNone borderRadius2 padding0p3 marginTop0p5 backgroundColorMagic' >
        <div className='borderNone borderRadius2 padding0p3 marginTop0p5 ' >
          { state.registeredCard[asset].name }
        </div>
      }
      else {
        cardName =
        <div className='borderNone borderRadius2 padding0p3 marginTop0p5 ' >
          { state.registeredCard[asset].name }
        </div>
      }
    }

    // // 魔法カラー

    // let backgroundColor;
    // let backgroundColorBox;

    // if (state.registeredCard[asset].category === 'magic' && position !== 'cast') {
    //   if (device === 'SP') {
    //     backgroundColor = 'backgroundColorTransparent';
    //     backgroundColorBox = 'backgroundColorMagic';
    //   }
    //   else { // PC
    //     backgroundColor = 'backgroundColorMagic';
    //     backgroundColorBox = 'backgroundColorTransparent';
    //   }
    // }
    // else {
    //   backgroundColor = 'backgroundColorTransparent';
    //   backgroundColorBox = 'backgroundColorTransparent';
    // }

    // カードイメージ結合品

    cardImage =
    <button className={styleBox + ' '} disabled={props.disabled ? true : false}
      onClick={ () => {
          let popup;

          if (device === 'SP') {
            const body = {
              item: {
                asset: asset, 
                index: index,
              },
              actionBox: 'close',
              position: position,
              source: 'history',
              monstersInformationRevisedSingleSide: monstersInformationRevisedSingleSide,
              imageNoSingleSide: imageNoSingleSide,
            };

            popup = { type: 'itemDetailSP', body: body };
          }
          else {
            const body = {
              monster: {
                asset: asset, 
                index: index,
              },
              position: position,
              source: 'history',
              monstersInformationRevisedSingleSide: monstersInformationRevisedSingleSide,
              imageNoSingleSide: imageNoSingleSide,
            };

            popup = { type: 'monsterDetail', body: body };
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
      }}
    >
        <div className={styleCard + ' relative flexColumn '} >
          { cardStatusImage }
          { targetIndication }
          { screen }
          <img className='widthMax' src={cardImageUrl} alt='card' />
        </div>
        { cardName }
    </button>
  }


  return (
    <div className='flexColumn alignItemsCenter ' >
      { cardImage }
    </div>
  );
}


// DUEL TEXT IN HISTORY
function DuelTextInHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const round = state.getDuelHistory.round;
  const thisRound = props.record.result[round];
  // const gameOption = props.record.gameOption;
  const straightManText = thisRound.straightManText;
  const fontSizeClass = props.fontSizeClass;

  let magicTextDiv;
  let magicTextDivSP;
  const magicText = magicNarration(state, thisRound.magics, thisRound.initiative, thisRound.monsters);

  if (magicText !== '') {
    magicTextDiv =
    <div className='marginTopBottom1'>
      { magicText }
    </div>;

    magicTextDivSP =
    <div className='marginTopBottom0p5'>
      { magicText }
    </div>
  }

  // つっこみ

  let straightManTextFormatted;
  const controlCodeFinished = '<-KOM-finished->';

  // if (gameOption?.A?.straightMan !== undefined && gameOption.A.straightMan.type !== 'none' || gameOption?.B?.straightMan !== undefined && gameOption.B.straightMan.type !== 'none') 
  if (straightManText !== undefined && straightManText !== null && straightManText !== '') {
    const straightManTextReplaced = straightManText.replace(controlCodeFinished, ''); // 昔のデュエル履歴には、controlCodeFinishedが付いているので、この処理は必要。

    straightManTextFormatted = '<<つっこみ>>\n' + straightManTextReplaced;
  }


  return (
    <>
      {/* PC */}
      <div className='visibleHuge'>
        <div className='flexColumn justifyContentFlexStart alignItemsFlexStart boxDuelTextBattleStory '>
          { magicTextDiv }
          <div className='marginTopBottom1'>
            { props.record.result[state.getDuelHistory.round].liveText }
          </div>
          <div className='marginTopBottom1'>
            { '<<フィールドの状況>>\n' + props.record.result[state.getDuelHistory.round].field }
          </div>
          <div className='marginTopBottom1'>
            { straightManTextFormatted }
          </div>
        </div>
      </div>
      {/* TABLET */}
      <div className='flexColumn visibleLarge '>
        <div className={'flexColumn justifyContentFlexStart alignItemsFlexStart boxDuelTextBattleStory boxDuelTextBattleStoryTablet ' + fontSizeClass} >
          { magicTextDivSP }
          <div className='marginTopBottom0p5'>
            { props.record.result[state.getDuelHistory.round].liveText }
          </div>
          <div className='marginTopBottom0p5'>
            { '<<フィールドの状況>>\n' + props.record.result[state.getDuelHistory.round].field }
          </div>
          <div className='marginTopBottom0p5'>
            { straightManTextFormatted }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className='flexColumn visibleMiddleOrLess '>
        <div className={'flexColumn justifyContentFlexStart alignItemsFlexStart boxDuelTextBattleStory boxDuelTextBattleStorySP ' + fontSizeClass} >
          { magicTextDivSP }
          <div className='marginTopBottom0p5'>
            { props.record.result[state.getDuelHistory.round].liveText }
          </div>
          <div className='marginTopBottom0p5'>
            { '<<フィールドの状況>>\n' + props.record.result[state.getDuelHistory.round].field }
          </div>
          <div className='marginTopBottom0p5'>
            { straightManTextFormatted }
          </div>
        </div>
      </div>
    </>
  );
}


export {
  DuelHistory,
  DuelHistoryDetailFullScreen,
  DuelHistoryDetail,
  DeckInHistorySP,
}